import { render, staticRenderFns } from "./AddNewOrder.component.vue?vue&type=template&id=11f1e8b8&scoped=true&"
import script from "./AddNewOrder.component.vue?vue&type=script&lang=js&"
export * from "./AddNewOrder.component.vue?vue&type=script&lang=js&"
import style0 from "./AddNewOrder.component.vue?vue&type=style&index=0&id=11f1e8b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f1e8b8",
  null
  
)

export default component.exports